<template>
  <div class="welcome"><h4>Request A Repair</h4></div>
  <br />

  <div class="">
    <div>
      <Back />
    </div>

    <br />
    <br />

    <img src="https://i.pinimg.com/originals/fa/87/77/fa87774590186b287a5338d7c87afc0c.gif">
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>